module.exports = __webpack_public_path__ + "img/pic_logo@2x.76c066fe.png";